import axios from "axios";
import config from "../config/app.config";
import { setAuthorizationToken } from "../helpers/axios";
import { getToken } from "../config/authsave";
setAuthorizationToken();

const Apibank = {
  gtdata_withdraws: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/gtdata_withdraw`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getDataSettlement: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getDataSettlements`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getDataClient_transfer: async (data) => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getdata_transaction_tranfer?limit=${data.limit}&offset=${data.offset}&startDate=${data.startDate}&endDate=${data.endDate}`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data,
    };

    return await axios(resData);
  },
  getDataStatement: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getDataStatements`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getData_topup: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getData-topup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  get_data_deposit: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/get_data_deposit`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  transferMoney: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/create_transaction_tranfer`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  verify_withdraw: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verify_withdraw`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  transferconfirmation: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/transferconfirmations`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  get_balance_summery: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/get_balance_summery`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  getUpdate_autokbank: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/update_autokbank`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getChack_stuaus_kbank: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/chack_stuaus_kbank`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  get_delete_bank_account: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/delete_bank_account`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  create_Manual: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/create_Manual`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    return await axios(resData);
  },
  upload_Manual: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/upload_Manual`,
      headers: {
        // 'Content-Type': 'application/json',
      },
      data: data,
    };

    return await axios(resData);
  },
  getall_Transaction_manuals: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getall_Transaction_manuals`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data,
    };

    return await axios(resData);
  },

  getdata_bankPlatform: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/getdata_bankPlatform`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken() || ""}`,
      },
      // data: data,
    };

    return await axios(resData);
  },
  upBank_level_deposit: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/upBank_level_deposit`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  upBank_level_withdrawal: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/upBank_level_withdrawal`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getApiTransferMoneyToAccount: async (data) => {
    console.log(data);
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/create_depprosit_krungthai`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getManualUploadSlip: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/chack_upload_Manual`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data,
    };
    return await axios(resData);
  },
  getManual_Processing: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/update_stust_Manual`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  getVerifyInfo: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verrify_tranfer_withdrowinq`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getStatusManual_Tranfer: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/getStatusManual_Tranfer`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getPayment: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/create_depositv1`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getConfirmTransfer: async () => {
    const resData = {
      method: "get",
      url: `${config.apiURL}/api/v1/admin/update_depprosit_krungthais`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: data,
    };
    return await axios(resData);
  },

  getInstructionViewType: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/instructionViewType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getReSend: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/resend_callback`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getConfirmTransaction: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/confirm-verifyslip`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  getVerifyslipTransactions: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/verifyslip-transactions`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  approveDeposit: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/approveTrans`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  getRejectDepositOnHold: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/update_deposit`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  
  ktb_request_otp: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/ktb_request_otp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
   ktb_confirm_otp: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/ktb_confirm_otp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },

  getEditDataBank: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/update_BankAccounts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  get_kbiz_login_qr: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/kbiz-login-qr`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  get_kbiz_logout_qr: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/kbiz-logout-qr`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
  get_confirm_kbiz_login_qr: async (data) => {
    const resData = {
      method: "post",
      url: `${config.apiURL}/api/v1/admin/kbiz-confirm-login-qr`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    return await axios(resData);
  },
};
export default Apibank;
